export const resolvePaymentDocumentInvoiceId = (
  transactionType: string | null | undefined,
  invoiceDataId: string | null | undefined,
  invoiceId: string | null | undefined
) => ((transactionType || '1') === '1' ? invoiceDataId || invoiceId || null : null);
